import {
    Card,
    CardBody,
    CardFooter,
    Col,
    Container,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Image,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
} from "react-bootstrap";
import {
    BsArrowDown,
    BsArrowRight,
    BsCalendar,
    BsCurrencyDollar,
    BsLayoutThreeColumns,
    BsPrinter,
    BsReceipt,
    BsShield,
    BsVr,
    BsWallet2,
} from "react-icons/bs";
import { FaCopy } from "react-icons/fa6";
import { FiDownload } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";

import { GrStatusInfo } from "react-icons/gr";

import bgImg1 from "assets/img/bg/01.jpg";
import satimImg from "assets/img/payment/3020.png";
import checkMyTrip from "assets/img/checkmytrip.png";

import { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { waveform } from "ldrs";
import useApiClient from "hooks/useApiClient";
import useToggle from "hooks/useToggle";
import { formatPrice } from "helpers/common";
import { useTranslation } from "react-i18next";
import ScrollToTop from "component/Common/ScrollToTop";

waveform.register();
const EditTicketArea = () => {
    const { api, urls } = useApiClient();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [data, setData] = useState(null);
    const pnr = searchParams.get("pnr");
    const name = searchParams.get("name");
    const [loading, setLoading] = useState(false);
    const [eticketEmail, setEticketEmail] = useState("");
    const [eticketEmailError, setEticketEmailError] = useState("");
    const { isOpen, toggle } = useToggle();
    const [isShaking, setIsShaking] = useState(false);
    const [emailType, setEmailType] = useState("");
    const airlinesUrl = `${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}`;

    const fetchDetails = useCallback(async () => {
        if (!pnr || !name) return;
        setLoading(true);

        try {
            const response = await api.get(
                `${urls.flight.getTicket}?pnr=${pnr}&name=${name}`
            );
            if (response.data.success) {
                setData({
                    ...response.data,
                    booking: response.data.data,
                });
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [api, urls.flight.getTicket, pnr, name]);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    const handlePrintEticket = () => {
        const queryParams = new URLSearchParams();
        queryParams.append("id", data?.bookingKey);
        queryParams.append(
            "token",
            JSON.parse(localStorage.getItem("user-session") || "{}")?.session
                ?.token
        );
        const requestUrl = `${process.env.REACT_APP_SERVER_URL}${urls.flight.eticket}?${queryParams}`;
        window.open(requestUrl, "_blank");
    };
    const handlePrintReceipt = () => {
        const queryParams = new URLSearchParams();
        queryParams.append("id", data?.bookingKey);
        queryParams.append(
            "token",
            JSON.parse(localStorage.getItem("user-session") || "{}")?.session
                ?.token
        );
        const requestUrl = `${process.env.REACT_APP_SERVER_URL}${urls.flight.receipt}?${queryParams}`;
        window.open(requestUrl, "_blank");
    };
    const validateEticketEmail = (e) => {
        const email = e.target.value;
        setEticketEmail(email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (!email) {
            setEticketEmailError("Email is required.");
        } else if (!emailRegex.test(email)) {
            console.log("bad");
            setEticketEmailError("Please enter a valid email address.");
        } else {
            setEticketEmailError("");
        }
    };
    const handleSendEmailEticket = (e) => {
        e.preventDefault();
        if (eticketEmailError === "") {
            const queryParams = new URLSearchParams();
            queryParams.append("email", eticketEmail);
            setEticketEmail("");
            queryParams.append("id", data?.bookingKey);
            let requestUrl = "";
            if (emailType === "reciept") {
                requestUrl = `${urls.flight.receiptEmail}?${queryParams}`;
            } else if (emailType === "e-ticket") {
                requestUrl = `${urls.flight.eticketEmail}?${queryParams}`;
            }
            api.get(requestUrl)
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                    toggle();
                });
        } else {
            shakeAnimation();
        }
    };

    const shakeAnimation = () => {
        setIsShaking(true);
        setTimeout(() => {
            setIsShaking(false);
        }, 2000);
    };

    const copyToClipboard = () => {
        const url = window.location.href;
        navigator.clipboard
            .writeText(url)
            .then(() => {
                alert("URL copied to clipboard!");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    if (loading) {
        return (
            <div
                className="w-100   d-flex  justify-content-center align-items-center"
                style={{ height: "60dvh" }}
            >
                <l-waveform
                    size="35"
                    stroke="3.5"
                    speed="1"
                    color={"black"}
                ></l-waveform>
            </div>
        );
    }

    if (!data || !data?.booking) {
        return (
            <section className="pt-4 ">
                <Container>
                    <Row>
                        <Col md={10} xl={10} className="mx-auto">
                            <Card
                                className="shadow"
                                style={{ height: "60dvh" }}
                            >
                                <CardBody className="text-center p-4 d-flex flex-column align-items-center justify-content-center">
                                    <h1
                                        className="card-title fs-3"
                                        style={{ color: "red" }}
                                    >
                                        {t("noBookingFound")}
                                    </h1>
                                    <h5>{t("checkYourEmail")}</h5>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }

    return (
        <section className="py-4 text-[14px]" >
            <ScrollToTop/>
            <Container>
                <Row>
                    <Col md={10} xl={10} className="mx-auto">
                        <Card className="shadow">
                            <Image
                                src={bgImg1}
                                className="rounded-top"
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "cover",
                                }}
                            />
                            <CardBody className="text-center p-4">
                                <Row>
                                    <a
                                        href="https://www.checkmytrip.com"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img
                                            src={checkMyTrip}
                                            width="140px"
                                            height="40px"
                                            alt="check_mytrip"
                                        />
                                    </a>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "20px" }}
                                        ></div>
                                    </Col>
                                </Row>
                                <Row className="justify-content-between text-start mb-4">
                                    <Col lg={12}>
                                        <ul className="list-group list-group-borderless">
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsVr className=" fa-fw me-2" />
                                                    {t("transactionId")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment?.order_id ||
                                                        data?.payment?.oderId}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsReceipt className=" fa-fw me-2" />
                                                    {t("orderNumber")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment
                                                        ?.order_number ||
                                                        data?.payment
                                                            ?.OrderNumber}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsShield className=" fa-fw me-2" />
                                                    {t("authorizationNumber")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment
                                                        ?.approval_code ||
                                                        data?.payment
                                                            ?.approvalCode}
                                                </span>
                                            </li>
                                            {data?.payment?.params &&
                                                data?.payment?.params
                                                    ?.respCode_desc && (
                                                    <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                        <span className="mb-0 items-center flex">
                                                            <BsArrowDown className=" fa-fw me-2" />
                                                            {t("response")}
                                                        </span>
                                                        <span className="h6 fw-normal mb-0 success-text">
                                                            {
                                                                data?.payment
                                                                    ?.params
                                                                    ?.respCode_desc
                                                            }
                                                        </span>
                                                    </li>
                                                )}
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsWallet2 className=" fa-fw me-2" />
                                                    {t("paymentMethod")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    Carte Bancaire CIB/DAHABIA
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsLayoutThreeColumns className="fa-fw me-2" />
                                                    {t("reference")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.booking?.pnr} <br />
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <GrStatusInfo className=" fa-fw me-2" />
                                                    {t("statut")}
                                                </span>
                                                <span className="h6 fw-normal mb-0 success-text">
                                                    <span
                                                        className={
                                                            data?.booking
                                                                ?.status ===
                                                            "CONFIRMED"
                                                                ? "confirmed"
                                                                : data?.booking
                                                                      ?.status ===
                                                                      "CANCELED" ||
                                                                  data?.booking
                                                                      ?.status ===
                                                                      "REFUNDED"
                                                                ? "failed"
                                                                : data?.booking
                                                                      ?.status ===
                                                                  "PENDING"
                                                                ? "pending"
                                                                : ""
                                                        }
                                                    >
                                                        <b>
                                                            {
                                                                data?.booking
                                                                    ?.status
                                                            }
                                                        </b>
                                                    </span>
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsCalendar className=" fa-fw me-2" />
                                                    {t("validate_at")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {data?.payment?.timestamp}
                                                </span>
                                            </li>
                                            <li className="list-group-item d-sm-flex justify-content-between align-items-center">
                                                <span className="mb-0 items-center flex">
                                                    <BsCurrencyDollar className=" fa-fw me-2" />
                                                    {t("total")}
                                                </span>
                                                <span className="h6 fw-normal mb-0">
                                                    {formatPrice(
                                                        data?.booking?.price
                                                            ?.total
                                                    )}
                                                </span>
                                            </li>
                                        </ul>
                                        <div className="mt-4">
                                            En cas de problème avec votre carte
                                            CIB ,<br /> contactez la SATIM
                                            <Image
                                                src={satimImg}
                                                className="rounded-top"
                                                style={{
                                                    paddingInlineStart: "5px",
                                                    width: "70px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div style={{ overflowX: "auto" }}>
                                            <table className="table align-middle p-4 mb-0 table-hover">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-start"
                                                        >
                                                            {t("passenger")}
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0"
                                                        >
                                                            {t("type")}
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0"
                                                        >
                                                            {t("statut")}
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-end"
                                                        >
                                                            {t("ticketNumber")}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data?.booking?.etickets.map(
                                                        (passenger, indx) => {
                                                            return (
                                                                <tr key={indx}>
                                                                    <td>
                                                                        {
                                                                            passenger?.pax_name
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            passenger.type
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            className={
                                                                                passenger.status ===
                                                                                "CONFIRMED"
                                                                                    ? "confirmed"
                                                                                    : passenger.status ===
                                                                                          "CANCELED" ||
                                                                                      passenger.status ===
                                                                                          "REFUNDED"
                                                                                    ? "failed"
                                                                                    : passenger.status ===
                                                                                      "PENDING"
                                                                                    ? "pending"
                                                                                    : ""
                                                                            }
                                                                            style={{
                                                                                fontWeight:
                                                                                    "bold",
                                                                            }}
                                                                        >
                                                                            {
                                                                                passenger.status
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            passenger.ticket_number
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "40px" }}
                                        ></div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div style={{ overflowX: "auto" }}>
                                            <table className="table align-middle p-4 mb-0 table-hover">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-start"
                                                        >
                                                            {t("airports")}
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0"
                                                        >
                                                            {t("type")}
                                                        </th>
                                                        <th
                                                            scope="col"
                                                            className="border-0 rounded-end"
                                                        >
                                                            {t("baggage")}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        <>
                                                            {data?.booking?.bounds?.map(
                                                                (
                                                                    bound,
                                                                    indx
                                                                ) => {
                                                                    return (
                                                                        <tr
                                                                            key={
                                                                                indx
                                                                            }
                                                                        >
                                                                            <td className="text-wrap items-center">
                                                                                <div className="d-flex flex-wrap align-items-center gap-1 gap-sm-2">
                                                                                    <span className="text-nowrap">
                                                                                        {bound?.departure_location?.iata || bound?.departure_location?.airport}
                                                                                    </span>
                                                                                    <BsArrowRight className="mx-1 mx-sm-2 flex-shrink-0" />
                                                                                    <span className="text-nowrap">
                                                                                        {bound?.arrival_location?.iata || bound?.arrival_location?.airport}
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    bound
                                                                                        ?.segments[0]
                                                                                        ?.baggage_info[0]
                                                                                        ?.pax_type
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                <span
                                                                                    style={{
                                                                                        fontWeight:
                                                                                            "bold",
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        bound
                                                                                            ?.segments[0]
                                                                                            ?.baggage_info[0]
                                                                                            ?.allowance
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "40px" }}
                                        ></div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col
                                        lg={12}
                                        className="flex justify-start items-center font-bold my-2"
                                    >
                                        {t("from")}{" "}
                                        {data.booking.bounds[0].origin}{" "}
                                        {t("to")}{" "}
                                        {data.booking.bounds[0].destination}
                                    </Col>
                                </Row>
                                {data?.booking?.bounds.map((bound) =>
                                    bound?.segments.map((segment, i) => (
                                        <Row
                                            key={`segment-${i}`}
                                            className="flex items-center "
                                            style={{ fontSize: "14px" }}
                                        >
                                            <Col xs={12} sm={12} md={2} lg={2} className="d-flex flex-column align-items-center mb-2 mb-md-0">
                                                <div className="d-flex flex-column align-items-center">
                                                    <Image
                                                        src={`${airlinesUrl}/${segment?.carrier}.png`}
                                                        alt="Airline Logo"
                                                        className="mb-1"
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                    <small className="text-muted d-none d-md-block">
                                                        {data.booking["airlines"][segment.carrier]?.airline || segment.carrier}
                                                    </small>
                                                </div>
                                            </Col>
                                            <Col xs={5} sm={5} md={3} lg={3} className="d-flex flex-column justify-content-center">
                                                <div className="d-flex flex-column">
                                                    <small className="text-muted d-none d-sm-block">
                                                        {segment?.departure_location?.["city_and_country"]}
                                                    </small>
                                                    <small className="text-muted d-sm-none">
                                                        {segment?.departure_location?.iata}
                                                    </small>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-bold">{segment?.departure_date}</span>
                                                        <span className="ms-2">{segment?.departure_time}</span>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col
                                                lg={1}
                                                className="font-bold text-lg flex items-center justify-center"
                                            >
                                                <BsArrowRight size={25} />
                                            </Col>
                                            <Col xs={5} sm={5} md={3} lg={3} className="d-flex flex-column justify-content-center">
                                                <div className="d-flex flex-column">
                                                    <small className="text-muted d-none d-sm-block">
                                                        {segment?.arrival_location?.["city_and_country"]}
                                                    </small>
                                                    <small className="text-muted d-sm-none">
                                                        {segment?.arrival_location?.iata}
                                                    </small>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="fw-bold">{segment?.arrival_date}</span>
                                                        <span className="ms-2">{segment?.arrival_time}</span>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={12} sm={12} md={3} lg={3} className="d-flex flex-column justify-content-center mt-2 mt-md-0">
                                                <div className="d-flex flex-wrap justify-content-between">
                                                    <small className="me-2">
                                                        {t("reservationClass")} <span className="fw-bold">{segment?.booking_class}</span>
                                                    </small>
                                                    <small>
                                                        {t("flightNumber")} <span className="fw-bold">{segment?.carrier}{segment?.flight_number}</span>
                                                    </small>
                                                </div>
                                            </Col>
                                        </Row>
                                    ))
                                )}
                                <Row>
                                    <Col lg={12}>
                                        <div
                                            style={{ marginBlock: "30px" }}
                                        ></div>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter className="resp-card-footer">
                                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-2">
                                    <Link
                                        className="btn btn-success"
                                        to={`/flight-booking-modification?pnr=${pnr}&name=${name}`}
                                    >
                                        {t("modifyMyTicket")}
                                    </Link>
                                    <div className="d-flex flex-column flex-sm-row justify-content-end gap-2">
                                        <Dropdown className="me-sm-2 mb-2 mb-sm-0">
                                            <DropdownToggle
                                                as="button"
                                                type="button"
                                                className="arrow-none btn btn-primary mb-0 w-100 items-center"
                                                role="button"
                                            >
                                                {t("receipt")}
                                            </DropdownToggle>
                                            <DropdownMenu
                                                align="end"
                                                className="min-w-auto shadow rounded p-2"
                                            >
                                                <li>
                                                    <DropdownItem
                                                        className="flex items-center gap-1"
                                                        onClick={() => {
                                                            handlePrintReceipt();
                                                        }}
                                                    >
                                                        <BsPrinter className="me-2" />
                                                        {t("print")}
                                                    </DropdownItem>
                                                </li>
                                                <li>
                                                    <DropdownItem
                                                        className="flex items-center gap-1"
                                                        onClick={() => {
                                                            handlePrintReceipt();
                                                        }}
                                                    >
                                                        <FiDownload className="me-2" />
                                                        {t("download")}
                                                    </DropdownItem>
                                                </li>
                                                <li>
                                                    <DropdownItem
                                                        className="flex items-center gap-1"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            toggle();
                                                            setEmailType("reciept");
                                                        }}
                                                    >
                                                        <MdOutlineEmail className="me-2" />
                                                        {t("email")}
                                                    </DropdownItem>
                                                </li>
                                                <li>
                                                    <DropdownItem
                                                        className="flex items-center gap-1"
                                                        onClick={() => {
                                                            copyToClipboard();
                                                        }}
                                                    >
                                                        <FaCopy className="me-2" />
                                                        {t("copyLink")}
                                                    </DropdownItem>
                                                </li>
                                            </DropdownMenu>
                                        </Dropdown>
                                        <Dropdown className="me-sm-2 mb-2 mb-sm-0">
                                            <DropdownToggle
                                                as="button"
                                                type="button"
                                                className="arrow-none btn btn-primary mb-0 w-100 items-center"
                                                role="button"
                                            >
                                                {t("eticket")}
                                            </DropdownToggle>
                                            <DropdownMenu
                                                align="end"
                                                className="min-w-auto shadow rounded p-2"
                                            >
                                                <li>
                                                    <DropdownItem
                                                        className="flex items-center gap-1"
                                                        onClick={() =>
                                                            handlePrintEticket()
                                                        }
                                                    >
                                                        <BsPrinter className="me-2" />
                                                        {t("print")}
                                                    </DropdownItem>
                                                </li>
                                                <li>
                                                    <DropdownItem
                                                        className="flex items-center gap-1"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            toggle();
                                                            setEmailType(
                                                                "e-ticket"
                                                            );
                                                        }}
                                                    >
                                                        <MdOutlineEmail className="me-2" />
                                                        {t("email")}
                                                    </DropdownItem>
                                                </li>
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal
                show={isOpen}
                onHide={toggle}
                size="lg"
                className="fade"
                id="cancellation"
                aria-hidden="true"
            >
                <ModalHeader>
                    <h5 className="modal-title">{t("sendByEmail")}</h5>
                    <button
                        type="button"
                        onClick={toggle}
                        className="btn-close"
                    />
                </ModalHeader>
                <ModalBody className="p-3">
                    <h6 className="text-center">
                        {t("pleaseEnterYourEmailBelow")}
                        <span className="text-danger">*</span>
                    </h6>
                    <Row className="g-3 justify-content-center m-4 mb-0">
                        <input
                            className={`form-control border-primary ${
                                eticketEmailError !== "" && "border-danger"
                            }`}
                            type="email"
                            placeholder="Enter your email..."
                            aria-label="email"
                            onChange={(e) => {
                                validateEticketEmail(e);
                            }}
                            value={eticketEmail}
                        />
                        {eticketEmailError !== "" ? (
                            <div
                                className={`mt-0 mb-0 text-danger ${
                                    isShaking ? "shake" : ""
                                } `}
                            >
                                {eticketEmailError}
                            </div>
                        ) : (
                            <div className="mb-2"></div>
                        )}
                    </Row>
                    <Row className="g-3 justify-content-start "></Row>
                    <Row className="g-3 justify-content-center m-4">
                        <Col xs={6} sm={4}>
                            <button
                                onClick={toggle}
                                className="btn btn-outline-danger w-100"
                            >
                                {t("cancel")}
                            </button>
                        </Col>
                        <Col xs={6} sm={4}>
                            <button
                                disabled={loading}
                                onClick={(e) => {
                                    handleSendEmailEticket(e);
                                }}
                                className={`btn btn-primary w-100 `}
                            >
                                {t("send")}
                            </button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </section>
    );
};

export default EditTicketArea;
